var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLineLink = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 19,
  height: 18,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.125,
  d: "M8.329 10.047a3.08 3.08 0 0 0 2.966.797c.517-.144.99-.418 1.37-.797l.728-.726 2.158-2.166A3.063 3.063 0 0 0 13.36 2a3.08 3.08 0 0 0-2.147.822L9.055 4.99"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.125,
  d: "m9.77 12.94-2.168 2.165a3.07 3.07 0 0 1-5.1-2.208c-.022-.78.254-1.54.772-2.124l2.17-2.166.726-.726a3.15 3.15 0 0 1 1.37-.796 3.08 3.08 0 0 1 2.967.796"
})));
export default SvgLineLink;